// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5006":"79af61be","6751":"100065f3","9249":"79af61be"}[chunkId] + ".chunk.css";
};